module.exports = __webpack_public_path__ + "img/studienschwerpunkte-medizininformatik.e51b7c2d.jpg";